import Component from './twitter_post_embed.vue'
export default Component
